import React, { useEffect } from 'react';

// @ts-expect-error FIXME: TS7006 - strict mode migration
export const useLocalStorage = (storageKey, fallbackState) => {
  const [value, setValue] = React.useState(
    // @ts-expect-error FIXME: TS2345 - strict mode migration
    JSON.parse(localStorage.getItem(storageKey)) ?? fallbackState
  );

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value, storageKey]);

  return [value, setValue];
};
